export var shadow = '$_26V4w';
export var diamondBackground = 'QAekQ';
export var formContent = '_1TECz';
export var icon = 'oVJ8f';
export var input = '$_39KCZ';